import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { storeSession } from './auth/cognito';

const hash = window.location.hash;
if (hash.includes('id_token=')) {
  const params = new URLSearchParams(hash.substring(1));
  const idToken = params.get('id_token');
  if (idToken) {
    storeSession(idToken);
    window.history.replaceState({}, document.title, '/');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode><App /></React.StrictMode>);